import type { ReportType } from '~/types/reports';
import type { AssetType } from '~/types';
import type { IconNames, IconProps } from '@workramp/ui';
import { Icon } from '@workramp/ui';
import { useTheme } from 'styled-components';
import { ICON_MAP, ICON_MAP_DUOTONE, ICON_WITH_SUBTYPE_MAP } from '~/constants/icons';
import { getColorFromType, getIconColor } from '~/utils';

type Props = {
  type: ReportType | AssetType;
  subType?: string | null;
  size?: IconProps['size'];
  useDuotone?: boolean;
  useBrandIconColor?: boolean;
};

export function ContentIcon({ type, subType, size, useDuotone, useBrandIconColor }: Props) {
  const theme = useTheme();

  let iconName: IconNames;

  if (subType) {
    iconName = ICON_WITH_SUBTYPE_MAP[type][subType];
  } else {
    iconName = (useDuotone ? ICON_MAP_DUOTONE : ICON_MAP)[type];
  }

  // Use brandIconColor when useBrandIconColor is true, otherwise use type-based color
  const defaultIconColor = getColorFromType(theme, type);
  const brandIconColor = defaultIconColor && getIconColor(defaultIconColor);
  const iconColor = useBrandIconColor ? brandIconColor : defaultIconColor;

  return <Icon name={iconName ?? 'null:regular'} color={iconColor} size={size} />;
}
